import dynamic from 'next/dynamic';

const EditARNMFileModal = dynamic(() =>
  import('./EditARNMFileModal/EditARNMFileModal')
);
const EditBillingInfoModal = dynamic(() =>
  import('./EditBillingInfoModal/EditBillingInfoModal')
);

const ImagesGalleryModal = dynamic(() =>
  import('./ImagesGalleryModal/ImagesGalleryModal')
);

const InfoTooltip = dynamic(() => import('./InfoTooltip/InfoTooltip'));
const SignatureModal = dynamic(() => import('./SignatureModal/SignatureModal'));
const ChangeBoardModal = dynamic(() =>
  import('./ChangeBoardModal/ChangeBoardModal')
);
const FiltersModalV2 = dynamic(() => import('./FiltersModalV2/FiltersModalV2'));
const Dialog = dynamic(() => import('./Dialog/Dialog'));
const ModalV2 = dynamic(() => import('./ModalV2/ModalV2'));
const ModalFormSection = dynamic(() => import('./ModalV2/ModalFormSection'));
const ModalFooter = dynamic(() => import('./ModalV2/ModalFooter'));
const Tooltip = dynamic(() => import('./Tooltip/Tooltip'));

export {
  EditARNMFileModal,
  EditBillingInfoModal,
  ImagesGalleryModal,
  InfoTooltip,
  SignatureModal,
  ChangeBoardModal,
  FiltersModalV2,
  Dialog,
  ModalV2,
  ModalFormSection,
  ModalFooter,
  Tooltip,
};
